/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SupportedCountryDto } from '../models/SupportedCountryDto';
import type { TimeZoneDto } from '../models/TimeZoneDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class SupportedCountryService {

    /**
     * Get supported countries
     * @returns SupportedCountryDto
     * @throws ApiError
     */
    public static supportedCountryControllerList(): CancelablePromise<Array<SupportedCountryDto>> {
        return __request({
            method: 'GET',
            path: `/supportedcountry`,
        });
    }

    /**
     * Get Time zones
     * @param countryCode
     * @returns TimeZoneDto
     * @throws ApiError
     */
    public static supportedCountryControllerTimeZone(
        countryCode?: string,
    ): CancelablePromise<Array<TimeZoneDto>> {
        return __request({
            method: 'GET',
            path: `/supportedcountry/timezone`,
            query: {
                'countryCode': countryCode,
            },
        });
    }

}